import { getApiErrorMessage } from '../api';

// Download endpoints return a Blob on both success and error. Decode only JSON
// errors, never inject a proxy HTML response into the application.
export async function reportExportError(error) {
  const data = error?.response?.data;
  if (data instanceof Blob) {
    try {
      const text = typeof data.text === 'function' ? await data.text() : await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsText(data);
      });
      const parsed = JSON.parse(text);
      return getApiErrorMessage({ ...error, response: { ...error.response, data: parsed } });
    } catch { /* Non-JSON errors use the safe status/network message below. */ }
  }
  return getApiErrorMessage(error);
}

export function downloadAuditReport(response, auditId, format, filename = `audit_report_${auditId}.${format}`) {
  const types = { pdf: 'application/pdf', docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' };
  const blob = new Blob([response.data], { type: response.headers?.['content-type'] || types[format] });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Safari may not have consumed the URL when click() returns.
  window.setTimeout(() => URL.revokeObjectURL(url), 60000);
}
